import React, { useContext } from 'react'
import styled from 'styled-components'
import {
  alignSelf as alignSelfStyle,
  fontWeight as fontWeightStyle,
  textAlign as textAlignStyle,
  space as spaceStyle,
  FontSizeProps,
  SpaceProps,
  TextAlignProps,
  TextStyleProps,
  LineHeightProps,
  TextColorProps
} from 'styled-system'
import { Heading, Text } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'

const StyledH1 = styled(Heading.h1)`
  ${textAlignStyle};
`

const StyledH2 = styled(Heading.h2)`
  ${alignSelfStyle};
  ${textAlignStyle};
  ${fontWeightStyle};
  ${spaceStyle};
`

type Headings = {
  [key: string]: React.ElementType
}

const HEADINGS: Headings = {
  h1: StyledH1,
  h2: StyledH2
}

type StyledHeadingType = FontSizeProps &
  SpaceProps &
  TextAlignProps &
  TextStyleProps &
  LineHeightProps &
  TextColorProps & {
    text: string
    tag: 'h1' | 'h2'
  }

export default function StyledHeading({
  color = 'text.base',
  text,
  fontSize = [3, 4, null, 5],
  textAlign,
  tag,
  textStyle,
  ...props
}: StyledHeadingType) {
  const Component = HEADINGS[tag]
  const { isMobile = false } = useContext(BootstrapDataContext)
  const bold = isMobile ? '600' : '700'

  return (
    <Component
      fontSize={fontSize}
      fontWeight={tag === 'h2' ? '400' : bold}
      textAlign={textAlign || 'left'}
      color={color}
      textStyle={textStyle}
      m={0}
      {...props}
    >
      <Text>{text}</Text>
    </Component>
  )
}
